import { Component } from "react";
import { apiRequest } from "../utils/apiClient";
import { clearCmsStorage } from "../helpers/storageUtils";

class CustomComponent extends Component {
    componentDidMount() {
        if (this._performAuthCheck !== false) {
            setTimeout(() => this.checkIsConnectedPWA(), 0);
        }
    }

    checkIsConnectedPWA() {
        const { t } = this.props;
        let account = localStorage.getItem("account");

        const anonymousRoutes = [
            "/login",
            "/password/reset",
            "/register",
            "/account/activate",
            "/boater",
        ];

        if (window.location.pathname.startsWith("/boater")) {
            this.logoutIfLoggedIn();
            return true;
        }

        if (localStorage.getItem("passwordNeedsChange") === "true") {
            this.safeNavigate("/password/edit");
            return true;
        }

        if (localStorage.getItem("cguNeedValidation") === "true") {
            this.safeNavigate("/account/accept_cgu");
            return true;
        }

        if (!account) {
            if (this.checker(window.location.pathname, anonymousRoutes))
                this.safeNavigate("/login");
            return false;
        }

        if (
            !this.checker(window.location.pathname, anonymousRoutes) &&
            account
        ) {
            this.props.addToast &&
                this.props.addToast(t && t("Already connected"), {
                    appearance: "success",
                    autoDismiss: true,
                    autoDismissTimeout: 4000,
                });
            this.safeNavigate("/");
        }
        return true;
    }

    async logoutIfLoggedIn() {
        let data = await this.request("/logged-in", "GET");
        if (data && data.status === "ok" && data.loggedIn) {
            await this.request("/logout", "GET");
            clearCmsStorage();
        }
    }

    safeNavigate(path) {
        setTimeout(() => {
            this.props.navigate(path);
        }, 0);
    }

    async checkIsConnected() {
        let url = "/login";
        let method = "GET";
        let data = await this.request(url, method);

        if (data && data.status === "ok" && data.loggedIn) return true;
        return false;
    }

    checker(value, arr) {
        return arr.every(function (v) {
            return value.indexOf(v) === -1;
        });
    }

    contains(target, pattern) {
        var value = 0;
        pattern.forEach(function (word) {
            value = value + target.includes(word);
        });
        return value >= 1;
    }

    handleInputChange(event, val, lsName, callback = null) {
        const target = event.target;
        let name = target.name || "";
        if (target.parentNode) {
            name = event.target.parentNode.classList.contains("MuiSlider-root")
                ? event.target.parentNode.querySelector("input").name
                : event.target.name;
        }
        let value = "";
        if (target.type !== undefined) {
            switch (target.type) {
                case "multicheckbox":
                    value = target.value;
                    break;
                case "checkbox":
                    value = target.checked;
                    break;
                case "submit":
                    if (target.id === "step-up")
                        value =
                            Number(this.state[lsName][name]) +
                            (target.step ? Number(target.step) : 1);
                    if (target.id === "step-down")
                        value =
                            Number(this.state[lsName][name]) -
                            (target.step ? Number(target.step) : 1);
                    break;
                default:
                    value = target.value;
                    break;
            }
        } else {
            value = val;
        }

        this.setState(
            (prevState) => {
                let cp = null;
                if (Array.isArray(lsName)) {
                    cp = Object.assign({}, prevState[lsName[0]]);
                    let obj = cp;
                    for (let i = 1; lsName.length > i; i++) {
                        obj = obj[lsName[i]];
                    }
                    obj[name] = value;
                    return { [lsName[0]]: cp };
                } else {
                    cp = Object.assign({}, prevState[lsName]);
                    cp[name] = value;
                    return { [lsName]: cp };
                }
            },
            () => {
                callback && callback();
            },
        );
    }

    /**
     * Makes an asynchronous request to the specified URL using the given method and optional body.
     *
     * @param {string} url - The URL to send the request to.
     * @param {string} method - The HTTP method to use for the request (e.g., "GET", "POST").
     * @param {string|object} [body=""] - The request body (optional).
     * @param {boolean} [isUploadForm=false] - Indicates whether the request is an upload form (optional).
     * @param {string} [csrfURL=""] - The URL to fetch CSRF token from (optional).
     * @param {object} [errorHandler={ isHandlingError: () => false, handleError: () => { } }] - The error handler object (optional).
     * @returns {Promise<object|null>} - A promise that resolves to the response data if successful, or null if an error occurred.
     */
    async request(
        url,
        method = "GET",
        body = "",
        isUploadForm = false,
        csrfURL = "",
        first_request = false,
        errorHandler = { isHandlingError: () => false, handleError: () => {} },
    ) {
        const { i18n, t, addToast } = this.props;

        return apiRequest({
            url,
            method,
            body,
            isUploadForm,
            csrfURL,
            firstRequest: first_request,
            errorHandler,
            dependencies: {
                navigate: (path) => this.safeNavigate(path),
                addToast,
                t,
                i18n,
            },
        });
    }

    loadStorageValues(actualStateNameArray, actualStateArray, callback = null) {
        if (actualStateNameArray.length === actualStateArray.length) {
            let updateCount = 0;
            const totalUpdates = actualStateNameArray.length;

            actualStateNameArray.forEach((key, index) => {
                let storageValue = {};
                let value;

                if (this.checkIsJSON(localStorage.getItem(key)))
                    storageValue = JSON.parse(localStorage.getItem(key));

                if (Array.isArray(actualStateArray[index])) {
                    value = storageValue ? storageValue : [];
                } else {
                    value = {};
                    Object.keys(actualStateArray[index]).forEach((setting) => {
                        value[setting] =
                            storageValue !== null &&
                            storageValue[setting] !== undefined
                                ? storageValue[setting]
                                : actualStateArray[index][setting];
                    });
                }

                if (
                    JSON.stringify(value) !==
                    JSON.stringify(actualStateArray[index])
                ) {
                    this.setState(
                        {
                            [key]: value,
                        },
                        () => {
                            updateCount++;
                            if (callback && updateCount === totalUpdates) {
                                callback();
                            }
                        },
                    );
                } else {
                    updateCount++;
                    if (callback && updateCount === totalUpdates) {
                        callback();
                    }
                }
            });
        }
    }

    async getCsrfToken(url) {
        let method = "GET";
        let data = await this.request(url, method);
        if (data) return data.token;
        return null;
    }

    checkIsJSON(text) {
        try {
            JSON.parse(text);
            return true;
        } catch {
            return false;
        }
    }

    async getFiles() {
        let url = "/company/files";
        let method = "GET";
        let files = await this.request(url, method);
        return files;
    }

    async getEntities() {
        let url = "/entity/list/all";
        let method = "GET";
        let entities = await this.request(url, method);
        return entities;
    }

    async getAccount(first_request = false) {
        let url = "/user/";
        let method = "GET";
        let data = await this.request(url, method, "", false, first_request);
        if (data && data.user) {
            // get files if exist
            let files = {};
            if (
                data.user.company &&
                (data.user.company.kbis_file || data.user.company.rib_file)
            ) {
                files = await this.getFiles();
            }
            let entities = await this.getEntities();
            if (data.roles) {
                data.user.roles = data.roles;
            }
            localStorage.setItem("account", JSON.stringify(data.user));
            localStorage.setItem(
                "files",
                JSON.stringify({
                    kbis: files.kbis ? files.kbis : "",
                    rib: files.rib ? files.rib : "",
                }),
            );
            localStorage.setItem("entities", JSON.stringify(entities.entities));
            return data.user;
        }
        return null;
    }

    getLocalStorageAccount() {
        let account = localStorage.getItem("account");
        if (account && this.checkIsJSON(account))
            account = JSON.parse(account) || [];
        return account;
    }

    loadRoles() {
        let roles = [];
        let account = localStorage.getItem("account");
        if (account && this.checkIsJSON(account)) {
            roles = JSON.parse(account).roles || [];
        }
        return roles;
    }

    loadMainRole() {
        let role = null;
        let account = localStorage.getItem("account");
        if (account && this.checkIsJSON(account)) {
            role =
                JSON.parse(account).roles.filter(
                    (role) => role !== "ROLE_USER",
                )[0] || [];
        }
        return role;
    }

    hasRole(role) {
        return this.loadRoles().includes(role);
    }
}

export default CustomComponent;
